// extracted by mini-css-extract-plugin
export default {"title_box":"productComponent_title_box__orcj8","img_box":"productComponent_img_box__QA-cX","line":"productComponent_line__y-3C6","app":"productComponent_app__OeWn8"};